import LinkIcon from '@mui/icons-material/Link';
import CodeIcon from '@mui/icons-material/Code';
import AndroidIcon from '@mui/icons-material/Android';
import PaymentsIcon from '@mui/icons-material/Payments';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import BusinessIcon from '@mui/icons-material/Business';
import enterprise from "../src/assets/images/services/blockchain/enterprise.png";
import logistics from "../src/assets/images/services/blockchain/logistics.png";
import solution from "../src/assets/images/services/blockchain/solution.png";
import development from "../src/assets/images/services/blockchain/development.png";
import strategic from "../src/assets/images/services/blockchain/strategic.png";
import consulting from "../src/assets/images/services/blockchain/consulting.png";
import security from "../src/assets/images/services/blockchain/security.png";
import blockchainnetwork from "../src/assets/images/services/blockchain/blockchainnetwork.png";
import ethereum from "../src/assets/images/services/blockchain/ethereum.png";
import ethereumtoken from "../src/assets/images/services/blockchain/ethereumtoken.png";
import blockchainplat from "../src/assets/images/services/blockchain/blockchainplat.png";
import dapp from "../src/assets/images/services/blockchain/dapp.png";
import enterpriseconsulting from "../src/assets/images/services/blockchain/enterpriseconsulting.png";
import enterpriseservice from "../src/assets/images/services/blockchain/enterpriseservice.png";
import smartartic from "../src/assets/images/services/smart/smartartic.png";
import smartwallet from "../src/assets/images/services/smart/smartwallet.png";
import smartnft from "../src/assets/images/services/smart/smartnft.png";
import smartdapp from "../src/assets/images/services/smart/smartdapp.png";
import smartaudit from "../src/assets/images/services/smart/smartaudit.png";
import threatmodeling from "../src/assets/images/services/smart/threatmodeling.png";
import autosecurity from "../src/assets/images/services/smart/autosecurity.png";
import securityplanning from "../src/assets/images/services/smart/securityplanning.png";
import crowd from "../src/assets/images/services/smart/crowd.png";
import moneyexchange from "../src/assets/images/services/smart/moneyexchange.png";
import cryptoexchange from "../src/assets/images/services/crypto/cryptoexchange.png";
import cryptoframework from "../src/assets/images/services/crypto/cryptoframework.png";
import bitcoinwallet from "../src/assets/images/services/crypto/bitcoinwallet.png";
import multicurrency from "../src/assets/images/services/crypto/multicurrency.png";
import cryptocoindev from "../src/assets/images/services/crypto/cryptocoindev.png";
import cryptocoinmining from "../src/assets/images/services/crypto/cryptocoinmining.png";
import centralizedwallet from "../src/assets/images/services/crypto/centralizedwallet.png";
import ethereumwallet from "../src/assets/images/services/crypto/ethereumwallet.png";
import decentralexchange from "../src/assets/images/services/crypto/decentralexchange.png";
import hybridexchange from "../src/assets/images/services/crypto/hybridexchange.png";
import nftexchange from "../src/assets/images/services/crypto/nftexchange.png";
import derivativesexchange from "../src/assets/images/services/crypto/derivativesexchange.png";
import dappdevelopment from "../src/assets/images/services/web3/dappdevelopment.png";
import web3integration from "../src/assets/images/services/web3/web3integration.png";
import web3app from "../src/assets/images/services/web3/web3app.png";
import web3development from "../src/assets/images/services/web3/web3development.png";
import gamedevelopment from "../src/assets/images/services/web3/gamedevelopment.png";
import gamedesign from "../src/assets/images/services/web3/gamedesign.png";
import seo from "../src/assets/images/services/web3/seo.png";
import socialmedia from "../src/assets/images/services/web3/socialmedia.png";
import metaverseblockchain from "../src/assets/images/services/metaverse/metaverseblockchain.png";
import custommetaverse from "../src/assets/images/services/metaverse/custommetaverse.png";
import metaverseintegration from "../src/assets/images/services/metaverse/metaverseintegration.png";
import metaverseconsulting from "../src/assets/images/services/metaverse/metaverseconsulting.png";
import mobilegame from "../src/assets/images/services/metaverse/mobilegame.png";
import strategy from "../src/assets/images/services/metaverse/Strategy.png";
import actiongame from "../src/assets/images/services/metaverse/actiongame.png";
import adventure from "../src/assets/images/services/metaverse/Adventure.png";
import nfttoken from "../src/assets/images/services/nft/nfttoken.png";
import assettoken from "../src/assets/images/services/nft/assettoken.png";
import nftwallet from "../src/assets/images/services/nft/nftwallet.png";
import nftmarket from "../src/assets/images/services/nft/nftmarket.png";
import nftconsulting from "../src/assets/images/services/nft/nftconsulting.png";
import nftsmartcontract from "../src/assets/images/services/nft/nftsmartcontract.png";
import branding from "../src/assets/images/services/nft/branding.png";
import multipleroyalties from "../src/assets/images/services/nft/multipleroyalties.png";
import gameandentertainment from "../src/assets/images/services/nft/game-entertainment.png";
import scalable from "../src/assets/images/services/nft/scalable.png";
import costeffective from "../src/assets/images/services/nft/cost-effective.png";
import innovation from "../src/assets/images/services/nft/innovation.png";
import seamlessintegration from "../src/assets/images/services/nft/seamless-integration.png";
import ongoingsupport from "../src/assets/images/services/nft/ongoing-support.png";
import softwareconsulting from "../src/assets/images/services/software/softwareconsulting.jpg";
import customsoftware from "../src/assets/images/services/software/customsoftware.jpg";
import softwareoutsourcing from "../src/assets/images/services/software/softwareoutsourcing.jpg";
import enterprisesoftware from "../src/assets/images/services/software/enterprisesoftware.jpg";
import applicationdevelopment from "../src/assets/images/services/software/applicationdevelopment.jpg";
import supportandmaintanence from "../src/assets/images/services/software/supportandmaintanence.jpg";


export const careerSlide = [
    {
        id: 1,
        title: "Digital Marketing",
        description: "SEO & SMM, Email, Content and Affiliate Marketing",
    },
    {
        id: 2,
        title: "Back-end Developer",
        description: "API, Database Handling, Server Handling",
    },
    {
        id: 3,
        title: "Blockchain Developer",
        description: "Development, Testing & Integration",
    },
    {
        id: 4,
        title: "UI-UX Designer",
        description: "Wireframe & Prototyping, Usability Testing",
    },
]

export const allServices = [
    {
        id: 1,
        title: "Blockchain Development",
        description: "Utilize blockchain technology to innovate and automate. We can assist you in developing scalable, secure, and individualized blockchain solutions.",
        icon: <LinkIcon />,
    },
    {
        id: 2,
        title: "Fullstack Web Development",
        description: "In order to meet the demands of small businesses, Kairaa Techserve provides excellent and reasonably priced web development services.",
        icon: <CodeIcon />,
    },
    {
        id: 3,
        title: "Android & IOS Applications",
        description: "To fully comprehend our client's demands and create an app that satisfies them, we work directly with them.",
        icon: <AndroidIcon />,
    },
    {
        id: 4,
        title: "Crypto Payment Integration",
        description: "Individuals can send money to one another securely and transparently using the crypto payment gateway offered by Kairaa.",
        icon: <PaymentsIcon />,
    },
    {
        id: 5,
        title: "Crypto Creation & Exchange",
        description: "With the help of a crypto exchange, you may instantly convert one digital currency into any other digital currencies.",
        icon: <CurrencyExchangeIcon />,
    },
    {
        id: 6,
        title: "NFT Projects",
        description: "A project must provide something unique and imaginative in order to differentiate itself from the rest of the competitors.",
        icon: <BusinessIcon />,
    },
]

export const blockchainDevelopment = [
    {
        id: 1,
        title: "Blockchain Solutions",
        description: "Boost efficiency with our blockchain scaling solutions. We develop sidechains and state channels to improve transaction speed and reduce costs.",
        icon: solution,
    },
    {
        id: 2,
        title: "Logistics",
        description: "Our blockchain experts are thoroughly prepared to optimize logistics operations, enhance shipment tracking, reduce errors, and improve transparency in the supply chain.",
        icon: logistics,
    },
    {
        id: 3,
        title: "Enterprise Blockchain Development",
        description: "We create permissioned blockchain networks tailored to enterprise needs. Our solutions streamline data sharing, automation, and transaction transparency.",
        icon: enterprise,
    },
    {
        id: 4,
        title: "Custom Blockchain Development",
        description: "Build your independent blockchain; we create custom blockchains like Ethereum, Solana, and Polkadot, ensuring scalability, security, and efficiency.",
        icon: development,
    },

]

export const blockchainConsulting = [
    {
        id: 1,
        title: "Strategic Consulting",
        description: "We take the time to understand your business goals and challenges. Together, we’ll figure out how blockchain can make a real difference and create a clear, actionable plan to integrate it seamlessly into your operations.",
        icon: strategic,
    },
    {
        id: 2,
        title: "Enterprise Blockchain Consulting",
        description: "Big businesses face unique challenges when adopting blockchain. We provide hands-on guidance, helping you design and implement large-scale blockchain systems that boost efficiency and keep you ahead of the competition.",
        icon: consulting,
    },
    {
        id: 3,
        title: "Blockchain Security Audit",
        description: "Keeping your blockchain system secure is essential. We’ll carefully review your smart contracts, applications, and platforms, identifying risks and providing actionable fixes to keep everything running safely.",
        icon: security,
    },
    {
        id: 4,
        title: "Blockchain Networks",
        description: "We create secure and scalable decentralized ecosystems, whether permission-based or permissionless, designed to operate with minimal downtime. As a leading blockchain consulting firm, we ensure the seamless design and deployment of robust blockchain networks.",
        icon: blockchainnetwork,
    },
]

export const Ethereum = [
    {
        id: 1,
        title: "Ethereum Blockchain Consulting",
        description: "We offer comprehensive blockchain consulting that helps you understand, analyze, and incomparably strategize high-performance Ethereum development projects.",
        icon: ethereum,
        height: 65,
        width: 65,
    },
    {
        id: 2,
        title: "Ethereum Token Development",
        description: "Our technical team aids you in Ethereum token development and optimizing tokens to simplify transactions and record balances.",
        icon: ethereumtoken,
        height: 40,
        width: 40,
    },
]

export const dApp = [
    {
        id: 1,
        title: "Blockchain Platform Selection",
        description: "We help you choose the most suitable blockchain platform for your dApps, whether it's Ethereum development services, Binance Smart Chain, Polkadot, or others. Our experts assess your specific requirements, including transaction speed, scalability, security, and cost, to recommend the best platform for your needs. We ensure that the chosen blockchain platform aligns with your business goals and technical specifications.",
        icon: blockchainplat,
        height: 40,
        width: 40,
    },
    {
        id: 2,
        title: "Custom dApps Development",
        description: "We develop bespoke decentralized applications tailored to your specific business needs as part of our dapp development services, ensuring optimal performance and security. Our development process involves thorough analysis, design, development, and deployment phases, ensuring that your dApps are built to the highest standards. We focus on creating scalable and efficient solutions that can grow with your business and adapt to evolving market demands.",
        icon: dapp,
        height: 35,
        width: 35,
    },
]

export const enterpriseBlockchain = [
    {
        id: 1,
        title: "Enterprise Blockchain Consulting Services",
        description: "Strategically evaluate your business needs, identify the ideal blockchain architecture, and craft a tailored adoption roadmap to drive innovation and efficiency.",
        icon: enterpriseconsulting,
    },
    {
        id: 2,
        title: "Enterprise Blockchain Development Services",
        description: "Build secure, permissioned blockchain networks that safeguard sensitive business data while ensuring controlled access and operational integrity.",
        icon: enterpriseservice,
    },
]

export const smartDevelopment = [
    {
        id: 1,
        title: "Smart Contract Architecture",
        description: "Our expert team maintains a smooth workflow and follows the most acceptable smart contract architecture practices by ensuring there are no programming bugs.",
        icon: smartartic,
    },
    {
        id: 2,
        title: "Smart Contracts for Wallet",
        description: "With our dependable, smart contract development services, we can assist you in launching a highly secure crypto wallet for your company.",
        icon: smartwallet,
    },
    {
        id: 3,
        title: "Smart Contracts for NFT",
        description: "Get your highly secure smart contracts built and backed by professional expertise. We provide custom NFT smart contracts for the smooth functioning of all your needs.",
        icon: smartnft,
    },
    {
        id: 4,
        title: "Smart Contract For dApps",
        description: "The main task here would be ensuring high levels of scalability with new applications. Each and every software can be trustworthy and functional with dApps and smart contracts.",
        icon: smartdapp,
    },
]

export const smartAudit = [
    {
        id: 1,
        title: "Smart Contract Audit",
        description: "Our smart contract security audit services include providing code analysis for teams wanting to launch blockchain applications. Any flaws relating to compilation, security, etc. are looked after by our blockchain experts.",
        icon: smartaudit,
    },
    {
        id: 2,
        title: "Threat Modeling",
        description: "Potential risks that can occur in the future are taken care of. The threat model is updated mainly for any possibilities of hacks by identifying entry points.",
        icon: threatmodeling,
    },
    {
        id: 3,
        title: "Automated Security Analysis",
        description: "Identifying bugs in the code to prevent vulnerable attacks on security. We use MythX for Ethereum and other types of blockchain smart contracts to carry out automated security analysis.",
        icon: autosecurity,
    },
    {
        id: 4,
        title: "Security Incident Planning",
        description: "Team up with our experts to develop monitoring of the infrastructure. Learn to quickly identify, report and repair any sort of security attacks.",
        icon: securityplanning,
    },
]

export const solidityDevelopment = [
    {
        id: 1,
        title: "CrowdSale Contracts Creation",
        description: "Our Solidity developers create smart contracts that are specially crafted for the CrowdSale Round to ensure that the distribution of tokens can be managed more securely and efficiently.",
        icon: crowd,
    },
    {
        id: 2,
        title: "Exchange Platform Development",
        description: "As a premier Solidity development company, we assist in developing an exchange platform specific to the niche of businesses safely & quickly by writing and deploying authenticated code.",
        icon: moneyexchange,
    },
]

export const cryptocurrencyDevelopment = [
    {
        id: 1,
        title: "Developing a Native Coin or a Blockchain",
        description: "This includes creating an entirely new blockchain from the ground up and a native cryptocurrency that runs on it. It provides the maximum customization options, enabling companies to design their own network architecture, consensus processes, and transaction rules.",
        icon: cryptoexchange,
        height: 35,
        width: 35,

    },
    {
        id: 2,
        title: "Forking the Existing Blockchain Framework",
        description: "Creating a new cryptocurrency by changing the source code of an existing blockchain, like Ethereum, is known as forking. This approach is less costly and faster than building an entirely new blockchain from scratch.",
        icon: cryptoframework,
        height: 45,
        width: 45,

    },
]

export const cryptowalletDevelopment = [
    {
        id: 1,
        title: "Bitcoin Wallet Development",
        description: "Kairaa offers unique and innovative Bitcoin wallet development services that provide potent wallets to conveniently store private transaction keys. Our expertise extends to various cryptocurrencies, including Bitcoin, ensuring a secure and user-friendly digital wallet for cryptocurrency solutions.",
        icon: bitcoinwallet,
    },
    {
        id: 2,
        title: "Multicurrency Wallet Creation",
        description: "Our cryptocurrency wallet development solutions help build a multi crypto currency wallet to keep your virtual currency safe and secure for transactions as per your specific needs. With our cryptocurrency multi wallet expertise in blockchain technology in developing secure wallets, we ensure that your multi cryptocurrency wallet supports many digital assets while prioritizing robust security measures.",
        icon: multicurrency,
    },
    {
        id: 3,
        title: "Crypto Coin Development",
        description: "At Kairaa, we leverage blockchain technology to develop the latest and in-demand crypto coins that are seamlessly compatible with various blockchain networks. Moreover, we provide support for integration with hardware cryptocurrency wallets, ensuring an added layer of protection for your digital assets.",
        icon: cryptocoindev,
    },
    {
        id: 4,
        title: "Crypto Coin Mining",
        description: "We assist in the mining of tokens and safely store them in a distributed database. Our developers use advanced cryptographic techniques to prevent fraudulent activities. Additionally, we provide support for secure storage through ledger wallet cryptocurrency solutions, offering an extra layer of protection for your digital assets.",
        icon: cryptocoinmining,
    },
    {
        id: 5,
        title: "Centralized Wallet Development",
        description: "Our team specializes in developing centralized wallets for our clients that offer a user-friendly interface and robust security measures. In addition, we provide integration support for a hardware wallet for cryptocurrency, ensuring an added layer of protection for your digital assets.",
        icon: centralizedwallet,
    },
    {
        id: 6,
        title: "Ethereum Wallet Development",
        description: "Our team at Kairaa specializes in developing Ethereum wallets for our clients that provide secure storage and easy management of ETH tokens. Additionally, we integrate support for crypto wallet hardware, enhancing the security and protection of your Ethereum-based digital assets.",
        icon: ethereumwallet,
    },
]

export const cryptoexchangeDevelopment = [
    {
        id: 1,
        title: "Decentralized Exchange",
        description: "Our team of developers specializes in decentralized crypto exchange development powered by smart contracts and blockchain protocols that eliminate third-party control.",
        icon: decentralexchange,
    },
    {
        id: 2,
        title: "Hybrid Cryptocurrency Exchange",
        description: "We create hybrid cryptocurrency exchange platforms that combine the speed and liquidity of centralized exchanges with the privacy and control of decentralized trading.",
        icon: hybridexchange,
    },
    {
        id: 3,
        title: "NFT Marketplace Exchange",
        description: "Tap into the booming NFT economy with our NFT exchange development services. We build platforms that support NFT minting, bidding, selling, and multi-chain compatibility.",
        icon: nftexchange,
    },
    {
        id: 4,
        title: "Derivatives & Futures Exchange",
        description: "Power up your platform with futures, options, and margin trading tools. Includes real-time liquidation engines, multi-leverage configurations, and more.",
        icon: derivativesexchange,
    },
]

export const web3Development = [
    {
        id: 1,
        title: "Web3 Custom dApp Development",
        description: "We focus on developing scalable, secure, and interoperable next-generation decentralized applications (dApps) using various languages and frameworks. Our expertise lies in creating custom web3 dApps tailored to specific requirements.",
        icon: dappdevelopment,
    },
    {
        id: 2,
        title: "Web3 Integration Services",
        description: "We create user-centric platforms along with the integration of modern and advanced features to the existing platforms that readily boost performance as well as the security of data.",
        icon: web3integration,
    },
    {
        id: 3,
        title: "Web3 Platform Development",
        description: "Our team of expert web3 developers helps create a decentralized and token-based platform which spins around the concepts of blockchain technology.",
        icon: web3development,
    },
]

export const web3gameDevelopment = [
    {
        id: 1,
        title: "Web3 Game Development",
        description: "Our skilled developers can develop your gaming platform from scratch or similar to popular web3 games through advanced programming techniques.",
        icon: gamedevelopment,
    },
    {
        id: 2,
        title: "Web3 Game Design",
        description: "Our talented designers can design in game tokens and assets with the best quality while fulfilling all your web3 gaming requirements.",
        icon: gamedesign,
    },
]

export const web3Marketing = [
    {
        id: 1,
        title: "Search Engine Optimization (SEO)",
        description: "Our Web3 marketing experts optimize your Web3 website for search engines, improving visibility and organic traffic to attract the right audience for your project.",
        icon: seo,
    },
    {
        id: 2,
        title: "Social Media Marketing",
        description: "Our Web3 marketing solutions let you engage your audience with platform-specific strategies for multiple social media platforms, driving organic growth.",
        icon: socialmedia,
    },
]

export const metaverseDevelopment = [
    {
        id: 1,
        title: "Blockchain & Web3 Integration",
        description: "We integrate NFTs, digital assets, crypto payments, and smart contracts for secure ownership and transaction systems within your Metaverse.",
        icon: metaverseblockchain,
    },
    {
        id: 2,
        title: "Custom Metaverse Development",
        description: "We build tailored Metaverse environments from virtual cities to enterprise spaces designed for your business goals and industry needs.",
        icon: custommetaverse,
    },
    {
        id: 3,
        title: "Metaverse Integration",
        description: "We integrate your existing systems, assets, and apps into the Metaverse, helping your business grab new opportunities without hassle.",
        icon: metaverseintegration,
    },
    {
        id: 4,
        title: "Metaverse Consulting",
        description: "We help you define strategies, identify opportunities, and build experiences that align perfectly with your business goals.",
        icon: metaverseconsulting,
    },
]

export const metaversegameDevelopment = [
    {
        id: 1,
        title: "Mobile Games",
        description: "Our team of metaverse game development experts develops 3D games and apps for platforms such as iPhone/iPad and Android-based devices.",
        icon: mobilegame,
    },
    {
        id: 2,
        title: "Strategy Games",
        description: "We design and release the most in-depth strategy games with stunning images and graphics that provide players with new difficulties on each level.",
        icon: strategy,
    },
    {
        id: 3,
        title: "Action Games",
        description: "Users may now make money just by playing engaging games, thanks to the advent of NFTs. NFTs may be used to sell metaverse racing game platform assets in the real world.",
        icon: actiongame,
    },
    {
        id: 4,
        title: "Adventure Games",
        description: "Metaverse NFT game creators can personalize each player's milestones and prizes. NFT may also help you keep track of events, triumphs, and landmarks in metaverse adventure games.",
        icon: adventure,
    },
]

export const nftMarketplace = [
    {
        id: 1,
        title: "NFT Token Development",
        description: "Kairaa helps you ace the NFT domain by creating unique and compatible tokens on different blockchain platforms.",
        icon: nfttoken,
    },
    {
        id: 2,
        title: "Asset Tokenization",
        description: "Speedy and secure tokenization of your digital asset on an integrated blockchain network tailored to your business requirement.",
        icon: assettoken,
    },
    {
        id: 3,
        title: "NFT Wallet Development",
        description: "Helping you develop secure wallets that offer multi-currency support, platform compatibility, QR scanner, transaction tracking etc.",
        icon: nftwallet,
    },
    {
        id: 4,
        title: "NFT Marketplace Support",
        description: "Monitoring and providing support for any new upgrades or glitches faced. Make sure that all nodes are functioning correctly.",
        icon: nftmarket,
    },
]

export const nftTokendevelopment = [
    {
        id: 1,
        title: "NFT Smart Contracts Audit",
        description: "As a premier NFT development company, we continuously maintain, monitor, as well as support NFT marketplaces in the non-fungible token market to make sure that they are up to date and running optimally.",
        icon: nftsmartcontract,
    },
    {
        id: 2,
        title: "NFT Consulting Service",
        description: "Kairaa offers top-notch NFT consulting services to help business owners and individuals gain a strong foothold in the non-fungible token development market without any kind of problems.",
        icon: nftconsulting,
    },
]

export const whitelabelNft = [
    {
        id: 1,
        title: "Effortless Company Branding",
        description: "With effortless company branding, we ensure that your marketplace reflects your unique identity, helping you establish a strong brand presence in the NFT space.",
        icon: branding,
    },
    {
        id: 2,
        title: "Multiple Royalties",
        description: "With multiple royalties functionality, you can manage royalties to various stakeholders involved in the NFT ecosystem, ensuring fair compensation and incentivizing creators.",
        icon: multipleroyalties,
    },
]

export const p2egameDevelopment = [
    {
        id: 1,
        title: "Gaming and Entertainment",
        description: "Our team of seasoned game developers and blockchain experts brings extensive experience to every project. Our deep understanding of play to earn game development technologies and methodologies ensures effective solutions that help you unlock the full potential of your game.",
        icon: gameandentertainment,
    },
    {
        id: 2,
        title: "Scalability and Flexibility",
        description: "Our play to earn game development solutions are designed with scalability in mind, allowing you to grow and adapt as your business evolves. Whether you’re a startup or a large enterprise, our flexible solutions accommodate increasing data volumes and complexity, ensuring long-term value and performance.",
        icon: scalable,
    },
    {
        id: 3,
        title: "Cost Efficiency",
        description: "By leveraging our expertise and advanced technologies, we help you reduce costs associated with game development and blockchain integration. Our efficient development processes and optimized solutions minimize operational expenses while maximizing your return on investment.",
        icon: costeffective,
    },
    {
        id: 4,
        title: "Innovation and Competitive Advantage",
        description: "Staying ahead of the competition requires constant innovation. Our play to earn game development enables you to harness emerging technologies like AI, blockchain, and NFTs to innovate and maintain a competitive edge. We help you identify new opportunities and trends that propel your business forward.",
        icon: innovation,
    },
    {
        id: 5,
        title: "Seamless Integration",
        description: "We ensure our play to earn game development services integrate seamlessly with your existing systems and processes. Our expertise in various platforms and technologies allows us to create solutions that work harmoniously with your current infrastructure, reducing disruptions and maximizing efficiency.",
        icon: seamlessintegration,
    },
    {
        id: 6,
        title: "Ongoing Support and Maintenance",
        description: "Our commitment to your success doesn’t end with the delivery of your play to earn game development solutions. We provide ongoing support and maintenance to ensure your systems continue to perform optimally. Our team is always available to address any issues, implement updates, and help you adapt to changing business needs.",
        icon: ongoingsupport,
    },
]

export const softwaredevService = [
    {
        id: 1,
        title: "Software Consulting",
        description: "Strategic technical guidance helping businesses make informed decisions about software investments.",
        image: softwareconsulting,
    },
    {
        id: 2,
        title: "Custom Software Development",
        description: "Scalable software development solutions designed specifically to address unique business challenges.",
        image: customsoftware,
    },
    {
        id: 3,
        title: "Software Outsourcing Services",
        description: "Providing expert development teams that work as extensions of your business.",
        image: softwareoutsourcing,
    },
    {
        id: 4,
        title: "Application Development",
        description: "Staying ahead of the competition requires constant innovation. Our play to earn game development enables you to harness emerging technologies like AI, blockchain, and NFTs to innovate and maintain a competitive edge.",
        image: applicationdevelopment,
    },
    {
        id: 5,
        title: "Enterprise Software Development",
        description: "Our expertise in various platforms and technologies allows us to create solutions that work harmoniously with your current infrastructure, reducing disruptions and maximizing efficiency.",
        image: enterprisesoftware,
    },
    {
        id: 6,
        title: "Support & Maintenance",
        description: "Providing technical assistance and continuous improvements for existing software.",
        image: supportandmaintanence,
    },
]